import { render, staticRenderFns } from "./caddies.vue?vue&type=template&id=2b059c64&scoped=true"
import script from "./caddies.vue?vue&type=script&lang=js"
export * from "./caddies.vue?vue&type=script&lang=js"
import style0 from "./caddies.vue?vue&type=style&index=0&id=2b059c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b059c64",
  null
  
)

export default component.exports